import PropTypes from 'prop-types';
import React from 'react';
import { Timeline } from 'antd';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import moment from 'utils/cops-moment';
import { withRouter } from 'utils/withRouter';
import SegmentInfo from './segment-info';

const ShortTimeline = styled(Timeline)`
  display: flex;
  padding: 0 0 10px 0 !important;
  .ant-timeline-item {
    flex: 1;
  }
  .ant-timeline-item-head,
  .ant-timeline-item-head-custom {
    top: auto;
    bottom: -5px;
    background-color: #ecf2f6;
    width: 22px;
    height: 22px;
    border-radius: 100px;
    border: 2px solid transparent;
    transform: none;
  }
  .ant-timeline-item-tail {
    left: 5px;
    bottom: 5px;
    width: 100%;
    height: auto;
    border-bottom: 2px solid #d6dee5;
    border-left: none;
  }
  .ant-timeline-item-content {
    top: 0;
    font-size: 1rem;
    padding: 0;
  }
`;

const Dot = styled.div`
  width: 100%;
  height: calc(100% + 8px);
  border: inherit;
  border-radius: 50%;
  margin-top: -4px;
  cursor: ${p => p.clickable && 'pointer'} !important;
  border-color: ${p => p.theme.colors.timeline[p.type]} !important;
  color: ${p => p.theme.colors.timeline[p.type]} !important;
  transition: background 0.3s ease-in !important;
  &:hover {
    background-color: ${p => p.theme.colors.timeline[p.type]};
  }
`;

const Date = styled.span`
  position: relative;
  left: 22px;
  bottom: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 12px;
`;

const ShortTermTimeline = ({
  segments: { firstPast, secondPast, present, firstFuture, secondFuture },
  history,
  intl,
}) => {
  const onClick = (segment) => {
    if (segment) {
      const segmentTimestamp = moment(segment.segmentDate).format('YYYY-MM-DD');
      const basePath = history.location.pathname.substring(
        0, history.location.pathname.lastIndexOf('/'),
      );
      history.push(`${basePath}/timeline/${segmentTimestamp}`);
    }
  };

  const getTimelineItem = ({ segment, type, isPresent = false }) => ({
    dot: <Dot
      onClick={() => onClick(segment)}
      clickable={!segment ? 0 : 1}
      type={type}
    >
      <Date>{segment && intl.formatDate(segment.segmentDate)}</Date>
    </Dot>,
    children: <SegmentInfo
      type={type}
      isPresent={isPresent}
      segment={segment}
      onClick={() => onClick(segment)}
    />,
  });

  const getTimelineItems = () => [
    getTimelineItem({ segment: secondPast, type: 'secondPast' }),
    getTimelineItem({ segment: firstPast, type: 'firstPast' }),
    getTimelineItem({ segment: present, type: 'present', isPresent: true }),
    getTimelineItem({ segment: firstFuture, type: 'firstFuture' }),
    getTimelineItem({ segment: secondFuture, type: 'secondFuture' }),
  ];

  return (
    <ShortTimeline
      items={getTimelineItems()}
    />
  );
};

ShortTermTimeline.propTypes = {
  segments: PropTypes.shape({
    firstPast: PropTypes.object,
    secondPast: PropTypes.object,
    present: PropTypes.object,
    firstFuture: PropTypes.object,
    secondFuture: PropTypes.object,
  }),
  intl: PropTypes.object,
  history: PropTypes.object,
};

export default withRouter(injectIntl(ShortTermTimeline));
